import React from 'react';

import { formatCaptureDeadline } from './preauthUtils';

interface PreAuthInfoBannerProps {
  saleRef: string;
  captureDeadline: string;
}

const PreAuthInfoBanner: React.FC<PreAuthInfoBannerProps> = ({ saleRef, captureDeadline }) => {
  return (
    <div
      style={{
        backgroundColor: '#E3F2FD',
        border: '1px solid #2196F3',
        borderRadius: '4px',
        padding: '12px 16px',
        marginBottom: '0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
      data-testid="preauth-info-banner"
    >
      <div>
        <span style={{ fontWeight: 'bold', color: '#1976D2', fontSize: '14px' }}>
          CURRENT SALE #{saleRef}
        </span>
      </div>
      <div>
        <span style={{ color: '#555', fontSize: '14px' }}>
          CAPTURE DEADLINE:{' '}
          <span style={{ fontWeight: 'bold', color: '#1976D2' }}>
            {formatCaptureDeadline(captureDeadline).toUpperCase()}
          </span>
        </span>
      </div>
    </div>
  );
};

export default PreAuthInfoBanner;
